
import React from "react";
import { FormField, FormItem, FormLabel, FormControl, FormMessage } from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import { useLanguage } from "@/context/LanguageContext";
import { UseFormReturn } from "react-hook-form";

interface VideoUrlFieldProps {
  form: UseFormReturn<any>;
  disabled?: boolean;
}

const VideoUrlField: React.FC<VideoUrlFieldProps> = ({ form, disabled = false }) => {
  const { language } = useLanguage();

  return (
    <FormField
      control={form.control}
      name="videoUrl"
      render={({ field }) => (
        <FormItem>
          <FormLabel>
            {language === "en" ? "Video URL (YouTube Embed)" : "رابط الفيديو (تضمين YouTube)"}
          </FormLabel>
          <FormControl>
            <Input 
              placeholder={language === "en" ? "Enter YouTube embed URL" : "أدخل رابط تضمين YouTube"} 
              {...field} 
              disabled={disabled}
            />
          </FormControl>
          <FormMessage />
        </FormItem>
      )}
    />
  );
};

export default VideoUrlField;
